import moment from "moment/moment";

export default {
    toDate(str, format) {
        return moment(str, format).toDate();
    },
    formatDay(amount, format) {
        return moment().add(amount, 'days').format(format);
    },
    formatDate(data, format) {
        return moment(data).format(format);
    },

    /**
     *
     * @param data
     * @param amount
     * @param unit years,months,days,hours,minutes,seconds,milliseconds
     * @param format
     * @returns {string}
     */
    formatComputeDate(data, amount, unit, format) {
        return moment(data).add(amount, unit).format(format);
    },
    formatSeconds(value, space) {
        if (value === "--") {
            return "--";
        }
        if (space) {
            space = " ";
        } else {
            space = "";
        }
        let secondTime = parseInt(value);// 秒
        let minuteTime = 0;// 分
        let hourTime = 0;// 小时
        if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
            //获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60);
            //获取秒数，秒数取余，得到整数秒数
            secondTime = parseInt(secondTime % 60);
            //如果分钟大于60，将分钟转换成小时
            if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取余的分，获取分钟除以60取余的分
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        let result = space + parseInt(secondTime) + space + "秒";

        if (minuteTime > 0) {
            result = space + parseInt(minuteTime) + space + "分" + result;
        }
        if (hourTime > 0) {
            result = space + parseInt(hourTime) + space + "小时" + result;
        }
        return result;
    },
    formatFloat(value) {
        if (value === "--") {
            return "--";
        }
        return parseFloat(value).toFixed(2);
    },
    json2FormData(data) {
        const formData = new FormData()
        Object.keys(data).forEach((i) => {
            if (typeof data[i] == 'string') {
                formData.append(i, data[i])
            } else {
                formData.append(i, JSON.stringify(data[i]))
            }
        })
        return formData;
    },
    json2FormUrlencoded(data) {
        // let formUrlencoded = "";
        // Object.keys(data).forEach((i) => {
        //     formUrlencoded += (i + "=" + data[i] + "&")
        // })
        // return formUrlencoded;
        return new URLSearchParams(data).toString();
    },
}